"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactDom = require("react-dom");

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _theme = require("HubStyleTokens/theme");

var _sizes = require("HubStyleTokens/sizes");

var _createChainablePropType = _interopRequireDefault(require("../utils/propTypes/createChainablePropType"));

var _ComponentWithWindowListeners = _interopRequireDefault(require("../mixins/ComponentWithWindowListeners"));

var _Functions = require("../core/Functions");

var _Overflows = require("../utils/Overflows");

var _UIList = _interopRequireDefault(require("../list/UIList"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _UIDropdown = _interopRequireDefault(require("../dropdown/UIDropdown"));

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _Styles = require("../utils/Styles");

var _tabUtils = require("./utils/tabUtils");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

var _Timers = require("../utils/Timers");

function _templateObject13() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n            border-left: 1px solid ", ";\n            border-radius: 0;\n          "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  /* Extra specificity to override .private-button-transparent.private-button--default rules */\n  &&& {\n    ", ";\n    flex-shrink: 0;\n\n    ", ";\n  }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          margin-bottom: 40px;\n\n          & > ", " {\n            padding-left: ", ";\n          }\n        "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  max-width: 100%;\n  ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          position: relative;\n          &::before {\n            border-top: 1px solid\n              ", ";\n            bottom: -1px;\n            content: '';\n            left: 0;\n            position: absolute;\n            width: 100%;\n          }\n        "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding: 16px;\n  border-top: 1px solid\n    ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          border-right: 1px solid ", ";\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          border-top: 1px solid ", ";\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          border: 1px solid ", ";\n          border-top-left-radius: ", ";\n          border-top-right-radius: ", ";\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          width: 100%;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n          padding-left: ", ";\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: ", ";\n  border-bottom: 1px solid\n    ", ";\n  margin-bottom: -1px;\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var isTabComponent = function isTabComponent(child) {
  var propTypes = child && child.type && child.type.propTypes;
  return propTypes && propTypes.tabId && propTypes.title;
};

var isWhitespace = function isWhitespace(str) {
  return typeof str === 'string' && !str.match(/\S/);
};

var getActiveTabPanel = function getActiveTabPanel(selected, childArray) {
  for (var i = 0; i < childArray.length; i++) {
    var child = childArray[i];

    var _ref = child && child.props ? child.props : {},
        tabContent = _ref.children,
        tabId = _ref.tabId;

    if (tabId === selected) {
      return tabContent;
    }
  }

  return null;
}; // `PropTypes.children`, but checks all children are `UITab` nodes


var childrenPropTypeValidator = (0, _createChainablePropType.default)(function (props, propName, componentName) {
  // Only accept UITab instances as children
  var valid = true;

  _react.Children.forEach(props[propName], function (child) {
    if (child != null && !isTabComponent(child) && !isWhitespace(child)) {
      valid = false;
    }
  });

  if (!valid) {
    return new Error(componentName + ": All children must be instances of UITab.");
  }

  return null;
}, 'node' // TODO: render "`UITab`s" instead, linked to the UITab docs
);
var StyledList = (0, _styledComponents.default)(function (props) {
  var __bordered = props.bordered,
      __use = props.use,
      __fill = props.fill,
      rest = (0, _objectWithoutProperties2.default)(props, ["bordered", "use", "fill"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UITabs__StyledList",
  componentId: "sc-1f5f8da-0"
})(_templateObject(), function (_ref2) {
  var use = _ref2.use;
  return (0, _tabUtils.isContained)(use) ? 'inline-flex' : 'flex';
}, function (_ref3) {
  var bordered = _ref3.bordered;
  return bordered ? _theme.TABS_BORDER_COLOR : 'transparent';
}, function (_ref4) {
  var use = _ref4.use;
  return use === 'header' ? (0, _styledComponents.css)(_templateObject2(), _sizes.LAYOUT_PADDING_X) : null;
}, function (_ref5) {
  var fill = _ref5.fill;
  return fill ? (0, _styledComponents.css)(_templateObject3()) : null;
}, function (_ref6) {
  var use = _ref6.use;
  return use === 'enclosed' ? (0, _styledComponents.css)(_templateObject4(), _theme.TABS_BORDER_COLOR, _sizes.BUTTON_RADIUS, _sizes.BUTTON_RADIUS) : null;
}, function (_ref7) {
  var use = _ref7.use;
  return use === 'flush' ? (0, _styledComponents.css)(_templateObject5(), _theme.TABS_BORDER_COLOR) : null;
}, function (_ref8) {
  var use = _ref8.use,
      fill = _ref8.fill;
  return (use === 'flush' || use === 'toolbar') && !fill ? (0, _styledComponents.css)(_templateObject6(), _theme.TABS_BORDER_COLOR) : null;
});
StyledList.displayName = 'UITabs__StyledUITabsList';
var TabsPanel = (0, _styledComponents.default)(_UISection.default).withConfig({
  displayName: "UITabs__TabsPanel",
  componentId: "sc-1f5f8da-1"
})(_templateObject7(), function (_ref9) {
  var bordered = _ref9.bordered;
  return bordered ? _theme.TABS_BORDER_COLOR : 'transparent';
});
var StyledWrapper = (0, _styledComponents.default)(function (props) {
  var __bordered = props.bordered,
      __use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["bordered", "use"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UITabs__StyledWrapper",
  componentId: "sc-1f5f8da-2"
})(_templateObject8(), function (_ref10) {
  var use = _ref10.use;
  return (0, _tabUtils.isContained)(use) ? (0, _styledComponents.css)(_templateObject9(), function (_ref11) {
    var bordered = _ref11.bordered;
    return bordered ? _theme.TABS_BORDER_COLOR : 'transparent';
  }) : null;
});
StyledWrapper.displayName = 'UITabs__StyledUITabsWrapper';
var StyledUITabs = (0, _styledComponents.default)(function (props) {
  var __use = props.use,
      __fill = props.fill,
      rest = (0, _objectWithoutProperties2.default)(props, ["use", "fill"]);
  return _react.default.createElement("div", rest);
}).withConfig({
  displayName: "UITabs__StyledUITabs",
  componentId: "sc-1f5f8da-3"
})(_templateObject10(), function (_ref12) {
  var use = _ref12.use;
  return use === 'header' ? (0, _styledComponents.css)(_templateObject11(), TabsPanel, _sizes.LAYOUT_PADDING_X) : null;
});
var ExcessTabsDropdownButton = (0, _styledComponents.default)(function (props) {
  var __parentUse = props.parentUse,
      rest = (0, _objectWithoutProperties2.default)(props, ["parentUse"]);
  return _react.default.createElement(_UIButton.default, rest);
}).withConfig({
  displayName: "UITabs__ExcessTabsDropdownButton",
  componentId: "sc-1f5f8da-4"
})(_templateObject12(), (0, _Styles.setInputMetrics)(_sizes.TAB_PADDING_Y, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_X, _sizes.TAB_PADDING_Y, false), function (_ref13) {
  var use = _ref13.parentUse;
  return (0, _tabUtils.isContained)(use) ? (0, _styledComponents.css)(_templateObject13(), _theme.TABS_BORDER_COLOR) : null;
});

var renderExcessTabsDropdown = function renderExcessTabsDropdown(moreTabsRenderer, childArray, excessTabCount, use, handleTabClick, refCallback) {
  if (moreTabsRenderer == null) return null;
  var excessTabs = childArray.slice(childArray.length - excessTabCount);
  var excessTabListItems = excessTabs.map(function (child) {
    var _ref14 = child && child.props ? child.props : {},
        onClick = _ref14.onClick;

    return _react.default.cloneElement(child, {
      className: 'private-tab--in-dropdown',
      onClick: (0, _Functions.memoizedSequence)(handleTabClick, onClick),
      active: false,
      children: null,
      role: 'button',
      tooltipPlacement: undefined
    });
  });
  var moreTabs = moreTabsRenderer({
    tabs: excessTabListItems,
    use: use
  });
  return _react.default.cloneElement(moreTabs, {
    ref: refCallback
  });
};

var UITabs = _react.default.createClass({
  displayName: "UITabs",
  mixins: [_reactAddonsPureRenderMixin.default, _ComponentWithWindowListeners.default],
  propTypes: {
    bordered: _react.PropTypes.bool.isRequired,
    children: childrenPropTypeValidator,
    fill: _react.PropTypes.bool,
    List: _component.default,
    listClassName: _react.PropTypes.string,
    moreTabsRenderer: _react.PropTypes.func,
    onSelectedChange: _react.PropTypes.func.isRequired,
    panelClassName: _react.PropTypes.string,
    selected: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
    use: _react.PropTypes.oneOf(_tabUtils.USES),
    Wrapper: _component.default,
    wrapperClassName: _react.PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      bordered: true,
      fill: false,
      moreTabsRenderer: function moreTabsRenderer(_ref15) {
        var tabs = _ref15.tabs,
            use = _ref15.use;
        return _react.default.createElement(_UIDropdown.default, {
          Button: ExcessTabsDropdownButton,
          "aria-hidden": true,
          buttonClassName: (0, _classNames.default)('private-tabs__excess-tabs-dropdown', {
            hidden: tabs.length === 0
          }),
          buttonText: _I18n.default.text('salesUI.UITabs.moreDropdownLabel'),
          buttonUse: "transparent",
          "data-dropdown-tabs": tabs.length,
          placement: "bottom left",
          responsive: false,
          tabIndex: -1,
          parentUse: use
        }, _react.default.createElement(_UIList.default, null, tabs));
      },
      List: StyledList,
      Wrapper: StyledWrapper
    };
  },
  getInitialState: function getInitialState() {
    return {
      excessTabCount: 0
    };
  },
  componentDidMount: function componentDidMount() {
    this.delayedFitToWidth();
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    if (prevState.excessTabCount === this.state.excessTabCount) {
      // All updates should trigger fitToWidth(), except updates that were
      // *caused* by fitToWidth()!
      this.delayedFitToWidth();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    (0, _Timers.cancelSchedulerCallback)(this._timeout);
  },
  getWindowListeners: function getWindowListeners() {
    return {
      resize: this.handleWindowResize
    };
  },
  handleWindowResize: function handleWindowResize() {
    this.delayedFitToWidth();
  },
  delayedFitToWidth: function delayedFitToWidth() {
    (0, _Timers.cancelSchedulerCallback)(this._timeout); // Ensure only one callback is queued at a time

    this._timeout = (0, _Timers.requestSchedulerCallback)(this.fitToWidth);
  },
  fitToWidth: function fitToWidth() {
    var moreTabsRenderer = this.props.moreTabsRenderer;

    if (moreTabsRenderer == null) {
      this.setState({
        excessTabCount: 0
      });
      return;
    } // Make sure we have a real container to work with


    var containerEl = this._containerEl;

    if (!containerEl || !document.body || !document.body.contains(containerEl)) {
      return;
    } // overflow: "visible" can cause clientWidth/scrollWidth to be miscalculated,
    // so we reset it to hidden until our computations are complete.


    var computedStyle = window.getComputedStyle(containerEl, null);
    if (computedStyle == null) return; // #4979

    var overflowVisible = computedStyle.overflow === 'visible';

    if (overflowVisible) {
      containerEl.classList.add('private-hide-overflow');
    }

    var newExcessTabCount = this.computeExcessTabCount(containerEl); // Reset the original element state

    if (overflowVisible) {
      containerEl.classList.remove('private-hide-overflow');
    }

    if (this.state.excessTabCount !== newExcessTabCount) {
      this.setState({
        excessTabCount: newExcessTabCount
      });
    }
  },
  computeExcessTabCount: function computeExcessTabCount(containerEl) {
    var excessTabsDropdownEl = (0, _reactDom.findDOMNode)(this._moreTabs);
    var tabEls = containerEl.querySelectorAll('.private-tab');
    var visibleTabs = tabEls.length;
    var i; // Let's start by hiding the dropdown control and showing all tabs.

    excessTabsDropdownEl.classList.add('hidden');

    for (i = tabEls.length - 1; i >= 0; i--) {
      var classList = tabEls[i].classList;

      if (classList.contains('sr-only')) {
        classList.remove('sr-only');
        classList.remove('sr-only-focusable');
        classList.add('private-tabs-sr-only-placeholder');
      }
    }

    if ((0, _Overflows.overflowsX)(containerEl)) {
      // Uh-oh, everything doesn't fit. Let's show that dropdown control, then
      // hide tabs (from right to left) until that changes.
      excessTabsDropdownEl.classList.remove('hidden');

      for (visibleTabs = tabEls.length - 1; visibleTabs >= 1; visibleTabs--) {
        tabEls[visibleTabs].style.display = 'none';

        if (!(0, _Overflows.overflowsX)(containerEl)) {
          break;
        }
      } // Restore all of the tabs we hid during the previous loop


      for (i = tabEls.length - 1; i >= visibleTabs; i--) {
        tabEls[i].style.display = '';
      }
    } // Restore all of the sr-only classes that we removed earlier.


    for (i = tabEls.length - 1; i >= 0; i--) {
      var _classList = tabEls[i].classList;

      if (_classList.contains('private-tabs-sr-only-placeholder')) {
        _classList.remove('private-tabs-sr-only-placeholder');

        _classList.add('sr-only');

        _classList.add('sr-only-focusable');
      }
    } // Show or hide the excess tabs dropdown as appropriate (don't rely on render reconciliation).


    excessTabsDropdownEl.classList[visibleTabs === tabEls.length ? 'add' : 'remove']('hidden');
    return tabEls.length - visibleTabs;
  },
  handleTabClick: function handleTabClick(evt) {
    this.props.onSelectedChange(evt);
  },
  containerRefCallback: function containerRefCallback(ref) {
    this._containerEl = (0, _reactDom.findDOMNode)(ref);
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        bordered = _this$props.bordered,
        children = _this$props.children,
        className = _this$props.className,
        fill = _this$props.fill,
        listClassName = _this$props.listClassName,
        moreTabsRenderer = _this$props.moreTabsRenderer,
        __onSelectedChange = _this$props.onSelectedChange,
        panelClassName = _this$props.panelClassName,
        selected = _this$props.selected,
        List = _this$props.List,
        use = _this$props.use,
        Wrapper = _this$props.Wrapper,
        wrapperClassName = _this$props.wrapperClassName,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["bordered", "children", "className", "fill", "listClassName", "moreTabsRenderer", "onSelectedChange", "panelClassName", "selected", "List", "use", "Wrapper", "wrapperClassName"]);
    var excessTabCount = this.state.excessTabCount;

    var childArray = _react.Children.toArray(children).filter(function (child) {
      return child && child.type;
    });

    var classes = (0, _classNames.default)(className, 'private-tabs', {
      'private-tabs--enclosed': use === 'enclosed',
      'private-tabs--header': use === 'header',
      'private-tabs--flush': use === 'flush',
      'private-tabs--toolbar': use === 'toolbar'
    }); // If the selected tab would be in the excess tab dropdown, move it to
    // first position instead.

    if (excessTabCount > 0) {
      for (var i = childArray.length - excessTabCount; i < childArray.length; i++) {
        if (childArray[i] && childArray[i].props.tabId === selected) {
          var firstChild = childArray[0];
          childArray[0] = childArray[i];
          childArray[i] = firstChild;
          break;
        }
      }
    }

    var activeTabPanel = getActiveTabPanel(selected, childArray);
    var componentRole = activeTabPanel ? 'tablist' : 'navigation';
    var excessTabsDropdown = renderExcessTabsDropdown(moreTabsRenderer, childArray, excessTabCount, use, this.handleTabClick, function (ref) {
      _this._moreTabs = ref;
    });
    var tabs = childArray.map(function (child, i) {
      var _ref16 = child && child.props ? child.props : {},
          active = _ref16.active,
          childClassName = _ref16.className,
          tabId = _ref16.tabId,
          onClick = _ref16.onClick;

      var hidden = i >= childArray.length - excessTabCount;
      var tabRole = activeTabPanel ? 'tab' : 'button';
      return _react.default.cloneElement(child, {
        onClick: (0, _Functions.memoizedSequence)(_this.handleTabClick, onClick),
        active: active != null ? active : tabId === selected,
        'aria-current': !activeTabPanel && tabId === selected ? 'page' : null,
        'aria-selected': activeTabPanel && tabId === selected ? true : null,
        children: null,
        className: (0, _classNames.default)(childClassName, {
          'sr-only': hidden,
          'sr-only-focusable': hidden
        }),
        role: tabRole,
        use: use,
        fill: fill
      });
    });
    return _react.default.createElement(StyledUITabs, (0, _extends2.default)({
      className: classes,
      use: use,
      fill: fill
    }, rest), _react.default.createElement(Wrapper, {
      bordered: bordered,
      className: (0, _classNames.default)('private-tabs__list__wrapper', wrapperClassName),
      ref: this.containerRefCallback,
      use: use
    }, _react.default.createElement(List, {
      bordered: bordered,
      className: (0, _classNames.default)('private-tabs__list', listClassName, {
        'private-tabs__list--enclosed': use === 'enclosed',
        'private-tabs__list--header': use === 'header',
        'private-tabs__list--fill': fill,
        'private-tabs__list--flush': use === 'flush',
        'private-tabs__list--toolbar': use === 'toolbar'
      }),
      role: componentRole,
      use: use,
      fill: fill
    }, tabs, excessTabsDropdown)), activeTabPanel ? _react.default.createElement(TabsPanel, {
      bordered: bordered,
      className: (0, _classNames.default)(panelClassName, 'private-tabs__panel'),
      role: "tabpanel"
    }, activeTabPanel) : null);
  }
});

var _default = (0, _Controllable.default)(UITabs, ['selected']);

exports.default = _default;
module.exports = exports.default;